import * as React from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import Editor from '../../components/Editor';
import Group from '../../components/Group';
import * as classnames from 'classnames';
import { Radio, Select } from 'antd';
import ScheduledPublishTime from '../../components/ScheduledPublishTime';
import './index.scss';
export default class ArticleEdit extends React.Component<any, any> {
    public resetCon = () => {
        this.props.resetCon();
    };
    public closeCrop = e => {
        this.props.closeCrop(e);
    };
    public cropImage = e => {
        this.props.cropImage(e);
    };
    public onChange = e => {
        this.props.onChange(e);
    };
    public getTitle = e => {
        this.props.getTitle(e);
    };
    public textareaOnFocus = () => {
        this.props.textareaOnFocus();
    };
    public timeOnchange = () => {
        this.props.timeOnchange();
    };
    public getPublicTime = e => {
        this.props.getPublicTime(e);
    };
    public commentChange = e => {
        this.props.commentChange(e.target.value);
    };
    public groupChange = val => {
        this.props.groupChange(val);
    };
    public render() {
        const {
            type,
            commentLimit,
            src,
            getChildRefs,
            HasTipShow,
            cropImg,
            cropHasHide,
            textareaHide,
            timingPublicBoxHasHide,
            articleTitle,
            editorContentLength,
            saveStatus,
            previewBoxHasHide,
            errorStatus,
            errorContent,
            avatar,
            userName,
            groupId,
            ...other
        } = this.props;
        console.log('rrewrwer',this.props.status===undefined);
        return (
            <div
                className="articleEditConBox"
                ref={ref => getChildRefs({ name: 'test', value: ref })}>
                <div className="createArticleConBox">
                    {HasTipShow && (
                        <div className="tipsInfo">
                            <span>已从草稿中恢复</span>
                            {
                                // tslint:disable-next-line: jsx-no-lambda
                                <span onClick={() => this.resetCon()}>
                                    撤销
                                </span>
                            }
                        </div>
                    )}
                    <div className="inputTitle">
                        {
                            // tslint:disable-next-line: jsx-no-lambda
                            <input
                                type="text"
                                placeholder="请输入标题（32字）"
                                value={articleTitle}
                                onChange={e => this.getTitle(e)}
                                maxLength={32}
                            />
                        }
                    </div>
                    <div className="textareaArticle">
                        <Editor
                            editorContentLength={editorContentLength}
                            {...other}
                        />
                        {
                            // tslint:disable-next-line: jsx-no-lambda
                            <textarea
                                className={classnames({ hide: textareaHide })}
                                name=""
                                id=""
                                cols={30}
                                rows={10}
                                placeholder="请输入正文"
                                onFocus={() =>
                                    this.textareaOnFocus()
                                }></textarea>
                        }
                        <span style={{ color: '#B1B1B1' }}>
                            字数 {editorContentLength}{' '}
                            {type !== 'update' && '(' + saveStatus + ')'}
                        </span>
                    </div>
                    <div className="cover-info-box">
                        <span className="cover-title">设置封面</span>
                        <div className="addCoverImgBox">
                            {!cropImg ? (
                                <div className="uploadBefore">
                                    <img
                                        src={require('../../assets/images/commonImg/loseImgIco.png')}
                                        alt=""
                                    />
                                    <p>点击添加封面图片</p>
                                    <p>
                                        支持JPG、PNG图片，建议尺寸1000px*400px
                                    </p>
                                </div>
                            ) : (
                                <div className="cropImg">
                                    <img src={cropImg} alt="" />
                                </div>
                            )}
                            <div
                                className={classnames('createCropBox', {
                                    hide: cropHasHide
                                })}>
                                <div className="cropBox">
                                    <div className="cropBoxHeader">
                                        <h4>裁切封面</h4>
                                        {
                                            // tslint:disable-next-line: jsx-no-lambda
                                            <span
                                                className="closeBtn"
                                                onClick={e =>
                                                    this.closeCrop(e)
                                                }>
                                                <img
                                                    src={require('../../assets/images/commonImg/closeBtn.png')}
                                                    alt=""
                                                />
                                            </span>
                                        }
                                    </div>
                                    {this.props.src ? (
                                        <Cropper
                                            ref={cropper =>
                                                getChildRefs({
                                                    name: 'cropper',
                                                    value: cropper
                                                })
                                            }
                                            src={src}
                                            style={{ height: 282, width: 500 }}
                                            // aspectRatio={16 / 9}
                                            guides={false}
                                            preview=".img-preview"
                                        />
                                    ) : null}

                                    <div className="cropBoxBottom">
                                        {
                                            // tslint:disable-next-line: jsx-no-lambda
                                            <span
                                                onClick={e =>
                                                    this.closeCrop(e)
                                                }>
                                                取消
                                            </span>
                                        }
                                        {
                                            // tslint:disable-next-line: jsx-no-lambda
                                            <span
                                                onClick={e =>
                                                    this.cropImage(e)
                                                }>
                                                确定
                                            </span>
                                        }
                                    </div>
                                </div>
                                {
                                    // tslint:disable-next-line: jsx-no-lambda
                                    <div
                                        className="cropBoxScreen"
                                        onClick={e => this.closeCrop(e)}></div>
                                }
                            </div>
                            {
                                // tslint:disable-next-line: jsx-no-lambda
                                <input
                                    type="file"
                                    ref={cropperInput =>
                                        getChildRefs({
                                            name: 'cropperInput',
                                            value: cropperInput
                                        })
                                    }
                                    className="uploadInput"
                                    onChange={e => this.onChange(e)}
                                    value=""
                                    accept="image/jpg,image/jpeg,image/png,image/gif"
                                    title=" "
                                />
                            }
                        </div>
                        <div className="comment-management-box">
                            <span className="comment-label">评论设置</span>
                            <Radio.Group
                                onChange={this.commentChange}
                                value={commentLimit}>
                                <Radio value={false}>开放评论</Radio>
                                <Radio value={true}>关闭评论</Radio>
                            </Radio.Group>
                        </div>
                        <div className="comment-management-box">
                            <span className="comment-label">圈子</span>
                            <Group disabled={!(`${this.props.status}` == '1'  || this.props.status === undefined)} value={this.props.groupId}  onChange={this.groupChange} placeholder="请选择"></Group>
                        </div>
                        <ScheduledPublishTime releaseType={this.props.releaseType} releaseTypeChange={this.props.releaseTypeChange} releaseTime={this.props.releaseTime} releaseTimeChange={this.props.releaseTimeChange} />
                    </div>
                </div>
            </div>
        );
    }
}
